import { useState } from 'react';

import jogoVelhaImage from '../../../img/jogo_da_velha.png';
import financasImage from '../../../img/financas.png';
import cassinoImage from '../../../img/cassino.png';
import calculadoraImage from '../../../img/calculadora.png';
import nexusImage from '../../../img/nexus.png';
import tabuadaImage from '../../../img/tabuada.png';
import urnaImage from '../../../img/urna.png';
import filmesImage from '../../../img/Captura de tela 2026-01-21 140419.png';

export const projects = [
  {
    title: 'Nexus API',
    description: 'Uma API social completa com funcionalidades avançadas e interface de usuário moderna. Código fonte não disponível.',
    image: nexusImage,
    github: null,
    demo: 'https://nexusapiapp.netlify.app/',
    technologies: ['Next.js', 'Nest.js', 'MongoDB', 'Bootstrap'],
  },
  {
    title: 'Finanças Pessoais',
    description: 'Aplicativo completo de gerenciamento financeiro pessoal com recursos avançados de controle de despesas, orçamentos e investimentos.',
    image: financasImage,
    github: 'https://github.com/Neil-Lima/financas_app',
    demo: 'https://financasappproject.netlify.app/',
    technologies: ['React', 'Node.js', 'MongoDB', 'Express', 'JWT', 'Material-UI'],
  },
  {
    title: 'Urna Eletrônica',
    description: 'Uma simulação interativa de urna eletrônica desenvolvida com Next.js, oferecendo uma experiência realista de votação.',
    image: urnaImage,
    github: 'https://github.com/Neil-Lima/urna_eletronica',
    demo: 'https://urnaeletronicaapp.netlify.app/',
    technologies: ['Next.js', 'React', 'TypeScript', 'Bootstrap'],
  },
  {
    title: 'Casino Web',
    description: 'Plataforma de cassino online com jogos interativos, sistema de apostas e design atraente.',
    image: cassinoImage,
    github: 'https://github.com/Neil-Lima/cassino',
    demo: 'https://cassinowebapp.netlify.app/',
    technologies: ['HTML', 'CSS', 'JavaScript', 'jQuery'],
  },
  {
    title: 'Jogo da Velha',
    description: 'Um jogo da velha interativo e responsivo com interface moderna, modos claro/escuro e placar personalizado.',
    image: jogoVelhaImage,
    github: 'https://github.com/Neil-Lima/Jogo_da_velha',
    demo: 'https://jogodavelhaapp.netlify.app/',
    technologies: ['HTML', 'CSS', 'JavaScript', 'Bootstrap'],
  },
  {
    title: 'Calculadora',
    description: 'Uma calculadora interativa com design moderno e funcionalidades avançadas.',
    image: calculadoraImage,
    github: 'https://github.com/Neil-Lima/calculadora',
    demo: 'https://minicalculadoraapp.netlify.app/',
    technologies: ['React', 'TypeScript', 'Styled Components'],
  },
  {
    title: 'Tabuada Interativa',
    description: 'Uma aplicação interativa para praticar e aprender tabuadas de forma divertida e eficiente.',
    image: tabuadaImage,
    github: 'https://github.com/Neil-Lima/tabuada',
    demo: 'https://tabuadaapp.netlify.app/',
    technologies: ['React', 'TypeScript', 'Redux', 'Styled Components'],
  },
  {
    title: 'Filmes Online',
    description: 'Plataforma de streaming de filmes e séries com catálogo completo, busca por gênero e paginação.',
    image: filmesImage,
    github: 'https://github.com/Neil-Lima/filmeonline',
    demo: 'https://filmeioline.netlify.app/home',
    technologies: ['Next.js', 'React', 'TypeScript', 'TanStack Query'],
  },
];

export const techIcons = {
  HTML: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg',
  CSS: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg',
  JavaScript: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg',
  Bootstrap: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-plain.svg',
  React: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg',
  'Node.js': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg',
  MongoDB: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg',
  Express: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg',
  JWT: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg',
  'Material-UI': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/materialui/materialui-original.svg',
  jQuery: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jquery/jquery-original.svg',
  TypeScript: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg',
  'Styled Components': 'https://raw.githubusercontent.com/styled-components/brand/master/styled-components.png',
  'Socket.io': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/socketio/socketio-original.svg',
  Redux: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg',
  'Next.js': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg',
  'Nest.js': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nestjs/nestjs-plain.svg',
  'Tailwind CSS': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-plain.svg',
  Prisma: 'https://www.prisma.io/images/favicon-32x32.png',
  'TanStack Query': 'https://tanstack.com/favicon.ico',
};

export const useProjects = () => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const handleOpenModal = (project) => {
    setSelectedProject(project);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return {
    openModal,
    selectedProject,
    handleOpenModal,
    handleCloseModal,
  };
};
